var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_4466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8142 7.19213V10.0566L15.4568 15.414C15.1394 15.7207 15.1306 16.2263 15.437 16.5437C15.7437 16.8608 16.2493 16.8696 16.5667 16.5632C16.5733 16.5569 16.5799 16.5503 16.5862 16.5437L21.9439 11.186H24.8081C25.02 11.186 25.2232 11.102 25.3728 10.9521L30.1655 6.15942C30.4776 5.84741 30.4776 5.34155 30.1655 5.02954C30.0156 4.87988 29.8125 4.79589 29.6008 4.79565H27.2046V2.39941C27.2044 1.95825 26.8467 1.60083 26.4055 1.60083C26.1939 1.60083 25.9907 1.68506 25.8408 1.83472L21.0481 6.62743C20.8985 6.77709 20.8142 6.98046 20.8142 7.19213Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5159 10.0962C15.2657 8.71726 11.5132 10.2346 10.1343 13.4848C8.75541 16.7351 10.2727 20.4878 13.523 21.8664C16.7732 23.2453 20.5259 21.7282 21.9046 18.4777C22.5816 16.8823 22.5816 15.0803 21.9046 13.4848L17.7163 17.6731C16.794 18.6223 15.2769 18.6443 14.3277 17.7221C13.3785 16.7998 13.3565 15.2827 14.2786 14.3335C14.2947 14.3169 14.3111 14.3008 14.3277 14.2846L18.5159 10.0962Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.114 8.4702L27.7238 10.8601C30.5637 17.3362 27.6162 24.8881 21.1401 27.728C14.6643 30.5678 7.11227 27.6201 4.27219 21.1443C1.43235 14.6682 4.3801 7.1162 10.8562 4.27636C14.1335 2.8391 17.8627 2.8391 21.1401 4.27636L23.5297 1.88598C15.7348 -2.27246 6.04465 0.675289 1.88621 8.4702C-2.27248 16.2649 0.675269 25.9553 8.47018 30.114C16.2651 34.2724 25.9553 31.3247 30.114 23.5297C32.6244 18.8237 32.6244 13.1762 30.114 8.4702Z",
    fill: "#900037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2159 7.19213C19.2149 6.56078 19.4644 5.95483 19.9099 5.50756C14.1019 3.33471 7.63213 6.28149 5.45904 12.0896C3.28619 17.8977 6.23296 24.3674 12.0411 26.5405C17.8492 28.7133 24.3189 25.7666 26.492 19.9585C27.4412 17.4214 27.4412 14.6267 26.492 12.0896C26.0447 12.5351 25.4387 12.7849 24.8074 12.7837H23.3316C25.1126 16.8379 23.2701 21.5681 19.2159 23.3491C15.1619 25.1303 10.4314 23.2876 8.65044 19.2336C6.86919 15.1794 8.71196 10.4492 12.7659 8.66796C14.8213 7.76513 17.1607 7.76513 19.2159 8.66796V7.19213Z",
    fill: "#900037"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_4466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVision);
export default __webpack_public_path__ + "static/media/our-vision.881c5dc2017ee594b5c1260b83f12c31.svg";
export { ForwardRef as ReactComponent };